import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  onUnauthorized?: () => void;
}

/**
 * ProtectedRoute component that wraps pages requiring authentication
 * Automatically redirects to login if user is not authenticated
 * Shows loading state while authentication is being checked
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  onUnauthorized 
}) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="protected-route-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // If not authenticated, trigger redirect callback
  if (!isAuthenticated) {
    if (onUnauthorized) {
      onUnauthorized();
    }
    return null;
  }

  // User is authenticated, render the protected content
  return <>{children}</>;
};

export default ProtectedRoute;